import { Popover, TableRow as MUITableRow } from '@mui/material';
import moment from 'moment-timezone';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { twMerge } from 'tailwind-merge';

import DownloadIcon from '../../../assets/svg/DownloadIcon';
import TranscriptIcon from '../../../assets/svg/TranscriptIcon';
import { DATE_TIME_FORMAT } from '../../../constants';
import { downloadRowsWithoutLead } from '../../../services/aidentifiedDataApi';
import { Icon, IconButton, TableBodyCell } from '../../Shared';

const ITEM_CLASS_NAME =
  'flex items-center gap-2 py-1.5 px-2 text-left rounded-lg hover:bg-base-700 font-medium text-[14px]/[20px] text-base-1000 disabled:opacity-50 disabled:pointer-events-none';

export const TableRow = ({
  upload,
  withBorderBottom,
  onOpenReport,
  onOpenDelete,
}) => {
  const {
    tenantName,
    fileName,
    exportDate,
    uploadedOn,
    uploadedBy,
    rowsTotal,
    rowsMatched,
    rowsWithoutLead,
  } = upload;

  const [anchorEl, setAnchorEl] = useState(null);

  const onDownload = async () => {
    setAnchorEl(null);

    try {
      await downloadRowsWithoutLead(upload);
    } catch {
      toast.error('Failed to download the rows!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const uploaded = moment(uploadedOn);

  return (
    <MUITableRow>
      <TableBodyCell
        withBorderBottom={withBorderBottom}
        width="150px"
        title={tenantName}
      >
        {tenantName}
      </TableBodyCell>
      <TableBodyCell
        withBorderBottom={withBorderBottom}
        width="178px"
        title={fileName}
      >
        {fileName}
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom} width="110px">
        {exportDate
          ? moment(exportDate, DATE_TIME_FORMAT.YYYY_MM_DD_DASH).format(
              DATE_TIME_FORMAT.MMM_D_YYYY,
            )
          : '-'}
      </TableBodyCell>
      <TableBodyCell
        withBorderBottom={withBorderBottom}
        width="116px"
        title={`${uploaded.format(DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A)} by ${uploadedBy}`}
      >
        {uploaded.format(DATE_TIME_FORMAT.MMM_D_YYYY)}
      </TableBodyCell>
      <TableBodyCell
        align="right"
        withBorderBottom={withBorderBottom}
        width="72px"
      >
        {rowsTotal.toLocaleString('en-US')}
      </TableBodyCell>
      <TableBodyCell
        align="right"
        withBorderBottom={withBorderBottom}
        width="140px"
        className="!font-semibold"
      >
        {rowsMatched.toLocaleString('en-US')}
      </TableBodyCell>
      <TableBodyCell
        align="right"
        withBorderBottom={withBorderBottom}
        width="122px"
      >
        {rowsWithoutLead.toLocaleString('en-US')}
      </TableBodyCell>
      <TableBodyCell
        align="center"
        withBorderBottom={withBorderBottom}
        width="56px"
      >
        <IconButton
          buttonProps={{
            className: 'w-8 h-8',
            'aria-label': `Actions for ${fileName}`,
            onClick: e => setAnchorEl(e.currentTarget),
          }}
          iconProps={{ name: 'dots', className: 'h-6' }}
        />
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          slotProps={{
            paper: {
              className:
                '!rounded-xl mt-1 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[260px]',
            },
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <div className="p-0.5 flex flex-col gap-0.5">
            <button
              type="button"
              className={ITEM_CLASS_NAME}
              onClick={() => {
                setAnchorEl(null);
                onOpenReport(upload);
              }}
            >
              <TranscriptIcon className="w-4 h-4 text-brand-900" />
              View report
            </button>
            <button
              type="button"
              className={ITEM_CLASS_NAME}
              disabled={rowsWithoutLead === 0}
              onClick={onDownload}
            >
              <DownloadIcon className="w-4 h-4 text-brand-900" />
              Download rows without a lead
            </button>
            <button
              type="button"
              className={twMerge(ITEM_CLASS_NAME, 'text-destructive-500')}
              onClick={() => {
                setAnchorEl(null);
                onOpenDelete(upload);
              }}
            >
              <Icon name="trash" className="w-4 h-4" />
              Delete upload
            </button>
          </div>
        </Popover>
      </TableBodyCell>
    </MUITableRow>
  );
};
